import { render, staticRenderFns } from "./Weekday.vue?vue&type=template&id=1488994e&"
import script from "./Weekday.vue?vue&type=script&lang=js&"
export * from "./Weekday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports